// extracted by mini-css-extract-plugin
module.exports = {"red__button":"style_red__button__1-szD","margin-right":"style_margin-right__3ATNO"};